// @flow
import initialState from "./initialState";
import * as ActionTypes from "../actions/actionTypes";
import { EntityList, Order } from "../flow/types";

export default function(
  state: EntityList<Order> = initialState.orders,
  action: any
) {
  switch (action.type) {
      case ActionTypes.GET_ORDERS + ActionTypes.FULFILLED:
      // var newState =  {Orders: action.payload.data};
      var data = action.payload.data;
      const result: EntityList<Order> = new EntityList(
        data.result,
        data.totalPages,
        data.totalRecords
      );
      return result;
    default:
      return state;
  }
}